module.exports = __webpack_public_path__ + "static/media/erik.87840ef9.png";